import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from 'react-router-dom'
import { useGetUsersQuery } from './usersApiSlice'
import { memo } from 'react'
import { ToggleButton, ButtonGroup, Spinner } from 'react-bootstrap';
import { useToggleSponsoredStatusMutation } from '../auth/authApiSlice';
import { useSelector } from 'react-redux';
import { selectAuthUser } from '../auth/authSlice';

const User = ({ userId }) => {
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[userId]
        }),
    });

    const navigate = useNavigate();
    const currentUser = useSelector(selectAuthUser);

    const [toggleSponsoredStatus, { isLoading }] = useToggleSponsoredStatusMutation();

    if (user) {
        const handleEdit = () => navigate(`/dashboard/users/${userId}`);

        const userRolesString = user.role.toString().replaceAll(',', ', ');

        const membershipTierDisplay = user.membershipTier || 'NONE';
        const membershipStatusDisplay = user.membershipStatus || 'INACTIVE';

        // ✅ userStatus के आधार पर सेल स्थिति, यदि ब्लॉक किया गया है तो इसे भी इंगित करें
        const cellStatus = user.userStatus === 'ACTIVE' && !user.isBlocked ? '' : 'table__cell--inactive';

        const handleToggleSponsored = async () => {
            try {
                await toggleSponsoredStatus({ userId: user.id, isSponsored: !user.isSponsoredMember }).unwrap();
            } catch (err) {
                console.error('प्रायोजित स्थिति टॉगल करने में विफल:', err);
                alert(`त्रुटि: ${err?.data?.message || 'प्रायोजित स्थिति अपडेट नहीं कर सका'}`);
            }
        };

        return (
            <tr className="table__row user">
                <td className={`table__cell ${cellStatus}`}>{user.name}</td>
                <td className={`table__cell ${cellStatus}`}>{user.email}</td>
                <td className={`table__cell ${cellStatus}`}>{user.mobile}</td>
                <td className={`table__cell ${cellStatus}`}>{userRolesString}</td>
                <td className={`table__cell ${cellStatus}`}>
                    {membershipTierDisplay}
                </td>
                <td className={`table__cell ${cellStatus}`}>
                    {membershipStatusDisplay}
                </td>
                <td className={`table__cell ${cellStatus}`}>
                    {currentUser?.role?.includes('ADMIN') ? (
                        <ButtonGroup toggle className="mb-2">
                            <ToggleButton
                                type="checkbox"
                                variant={user.isSponsoredMember ? 'success' : 'outline-secondary'}
                                checked={user.isSponsoredMember}
                                value="1"
                                onClick={handleToggleSponsored}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    user.isSponsoredMember ? 'प्रायोजित' : 'प्रायोजित नहीं'
                                )}
                            </ToggleButton>
                        </ButtonGroup>
                    ) : (
                        <span className={user.isSponsoredMember ? 'text-success' : 'text-muted'}>
                            {user.isSponsoredMember ? 'प्रायोजित' : 'प्रायोजित नहीं'}
                        </span>
                    )}
                </td>
                {/* ✅ नया कॉलम: ब्लॉक स्थिति */}
                <td className={`table__cell ${cellStatus}`}>
                    {user.isBlocked ? (
                        <span style={{ color: 'red', fontWeight: 'bold' }} title={user.blockedReason || 'ब्लॉक किया गया'}>
                            ब्लॉक किया गया
                        </span>
                    ) : (
                        <span style={{ color: 'green' }}>सक्रिय</span>
                    )}
                </td>
                <td className={`table__cell ${cellStatus}`}>
                    <button
                        className="icon-button table__button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                    {/* ✅ यदि आप यहां से सीधे डिलीट करना चाहते हैं तो DeleteUserMutation का उपयोग करें */}
                </td>
            </tr>
        )

    } else return null
}

const memoizedUser = memo(User)

export default memoizedUser
